// extracted by mini-css-extract-plugin
export default {"PlainFeature":"vx_a bhg_b"};